import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoSelectionCardIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Group 300",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 3464110",
				width: 200,
				height: 140,
				fill: "white"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group 299",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group 298",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group 279",
							children: [
								/* @__PURE__ */ _jsx("path", {
									id: "Vector 1125",
									d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
									fill: "#F0FAF8"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse 592",
									cx: 89.6406,
									cy: 120.66,
									r: 6,
									fill: "#F0FAF8"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse 593",
									cx: 40.6406,
									cy: 35.6602,
									r: 8,
									fill: "#F0FAF8"
								})
							]
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Rectangle 3464109",
						filter: "url(#filter0_d_4597_37393)",
						children: /* @__PURE__ */ _jsx("rect", {
							x: 34,
							y: 36,
							width: 132,
							height: 64,
							rx: 4,
							fill: "white"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M110 69.5004C110 81.9316 120.078 92.0004 132.5 92.0004C143.881 92.0004 153.284 83.5535 154.784 72.5941C154.794 72.5285 154.794 72.4629 154.794 72.4066C154.794 71.6285 154.147 71.0004 153.341 71.0004H131V48.6504C131 47.8441 130.372 47.1973 129.594 47.1973C129.528 47.1973 129.462 47.1973 129.406 47.2066C118.447 48.716 110 58.1285 110 69.5004Z",
						fill: "url(#paint0_linear_4597_37393)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M135.5 66.5H156.444C157.287 66.5 158 65.8438 158 65C158 53.4031 148.597 44 137 44C136.156 44 135.5 44.7125 135.5 45.5563V66.5Z",
						fill: "url(#paint1_linear_4597_37393)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M132 85.45V108.625C132 109.388 132.619 110 133.375 110C133.769 110 134.15 109.831 134.412 109.531L139.575 103.625L143.206 110.894C143.7 111.881 144.9 112.281 145.887 111.788C146.875 111.294 147.275 110.094 146.781 109.106L143.238 102H150.619C151.381 102 152 101.381 152 100.619C152 100.225 151.831 99.85 151.538 99.5875L134.412 84.3688C134.144 84.1313 133.806 84 133.45 84C132.65 84 132 84.65 132 85.45Z",
						fill: "url(#paint2_linear_4597_37393)"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Line 2",
						d: "M44 46H72",
						stroke: "url(#paint3_linear_4597_37393)",
						strokeWidth: 4,
						strokeLinecap: "round"
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_4597_37393",
				x: 6,
				y: 20,
				width: 180,
				height: 112,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -4,
						dy: 8
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_4597_37393"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_4597_37393",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4597_37393",
				x1: 132.397,
				y1: 47.1973,
				x2: 132.397,
				y2: 92.0004,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4597_37393",
				x1: 146.75,
				y1: 44,
				x2: 146.75,
				y2: 66.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4597_37393",
				x1: 142,
				y1: 84,
				x2: 142,
				y2: 111.999,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_4597_37393",
				x1: 44,
				y1: 46.5,
				x2: 72,
				y2: 46.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNoSelectionCardIcon);
export { ForwardRef as ReactComponent };
